export default function TrustStrip() {
  const items = [
    {
      text: "Trusted by global buyers & dropshippers",
      icon: "ri-global-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20globe%20illustration%20with%20connected%20dots%2C%20minimal%20line%20art%20style%2C%20warm%20cream%20background%2C%20clean%20modern%20design%2C%20global%20network%20concept&width=200&height=200&seq=trust-global-01&orientation=squarish"
    },
    {
      text: "Real-time updated product spreadsheet system",
      icon: "ri-refresh-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20refresh%20sync%20icon%20concept%2C%20circular%20arrows%20in%20warm%20neutral%20tones%2C%20clean%20cream%20background%2C%20simple%20modern%20design%2C%20data%20sync%20illustration&width=200&height=200&seq=trust-refresh-02&orientation=squarish"
    },
    {
      text: "No hidden sourcing fees",
      icon: "ri-shield-check-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20shield%20with%20checkmark%20illustration%2C%20clean%20line%20art%20style%2C%20warm%20cream%20background%2C%20trust%20and%20security%20concept%2C%20modern%20minimal%20design&width=200&height=200&seq=trust-fees-03&orientation=squarish"
    },
    {
      text: "Secure workflow with verified suppliers",
      icon: "ri-lock-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20lock%20security%20icon%20illustration%2C%20clean%20geometric%20style%2C%20warm%20cream%20background%2C%20secure%20protection%20concept%2C%20modern%20simple%20design&width=200&height=200&seq=trust-secure-04&orientation=squarish"
    },
  ];

  return (
    <section className="w-full bg-background-100 border-y border-background-200/60">
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {items.map((item) => (
            <div key={item.text} className="flex items-center gap-3 text-sm text-foreground-700 whitespace-nowrap">
              <div className="w-8 h-8 flex-shrink-0 rounded-lg overflow-hidden bg-background-50 border border-background-200/50">
                <img
                  src={item.imageUrl}
                  alt=""
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}